import { v4 as uuidv4 } from 'uuid';

/*
===  EJEMPLO DE ALERT  ===
const alert = {
  id: 1,
  showAlert: false,
  type:''
  message:''
}
*/
const namespaced = true;

const state = () => ({
  alerts: [],
});

const getters = {
  alerts(state) {
    return state.alerts;
  },
};

const mutations = {
  OPEN_ALERT(state, payload) {
    const alertFind = state.alerts.find((element) => element.id === payload.id);
    alertFind.showAlert = true;
  },
  CLOSE_ALERT(state, payload) {
    const alertFind = state.alerts.find((element) => element.id === payload.id);
    alertFind.showAlert = false;
  },
  ADD_ALERT(state, payload) {
    state.alerts.push(payload);
  },
  DELETE_ALERT(state, payload) {
    const newArray = state.alerts.filter(
      (element) => element.id !== payload.id
    );
    state.alerts = newArray;
  },
  CLEAR_DATA(state) {
    state.alerts = [];
  },
};

const actions = {
  async addAlert({ commit }, payload) {
    if (Object.keys(payload).length > 0) {
      const alert = handlePayload(payload);
      commit('ADD_ALERT', alert);
      await new Promise((resolve) => {
        setTimeout(() => {
          commit('CLOSE_ALERT', alert);
          resolve();
        }, 4700);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          commit('DELETE_ALERT', alert);
          resolve();
        }, 5500);
      });
    }
  },
};

function handlePayload(payload) {
  console.log('handlePayload: ', payload);
  payload.id = uuidv4();
  payload.showAlert = true;
  return payload;
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
